import { DESKTOP_WINDOW_SIZE, WINDOW_SCALE_FACTOR } from './ResponsiveLinkPreview.config';

/**
 * Calculates the scale factor and scaled height for the design preview based on the current window size.
 *
 * @returns An object containing the scaled height and full screen scale factor.
 */
export const getPreviewScale = () => {
  // fits about 50% of the screen
  const fullScreenScale = Math.min(window.innerWidth / WINDOW_SCALE_FACTOR / DESKTOP_WINDOW_SIZE.width);

  const scaledHeight = DESKTOP_WINDOW_SIZE.height * fullScreenScale;

  return { scaledHeight, fullScreenScale };
};
